import { render, staticRenderFns } from "./ClientChatbotList.vue?vue&type=template&id=7cf57a6e"
import script from "./ClientChatbotList.vue?vue&type=script&lang=js"
export * from "./ClientChatbotList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports